import { Pagination, SearchInput } from "ui";

import { PriceInsightsTable } from "../../components";
import { usePriceInsightsList } from "../../hooks";

import styles from "./PriceInsights.module.scss";

const PriceInsights = () => {
  const {
    priceInsights,
    isLoading,
    sorting,
    setSorting,
    totalItems,
    searchValue,
    page,
    setSearchValue,
    setPage
  } = usePriceInsightsList();

  return (
    <div className={styles.priceInsights}>
      <SearchInput
        value={searchValue}
        placeholder="Search..."
        onChange={setSearchValue}
      />

      <div className={styles.priceInsights_tableContainer}>
        <PriceInsightsTable
          products={priceInsights}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
        />
      </div>

      <Pagination
        currentPage={page}
        onChange={setPage}
        totalItems={totalItems}
      />
    </div>
  );
};

export default PriceInsights;
